"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styles = ({ palette, spacing }) => ({
    root: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: spacing(1.5),
        padding: `${spacing(1)} ${spacing(2)}`,
        backgroundColor: palette.surface.subtle3,
    },
    content: {
        display: 'flex',
        flex: '1 0 auto',
        alignItems: 'center',
        justifyContent: 'center',
        gap: spacing(1),
        minWidth: 0,
    },
    text: {
        color: palette.text.secondary,
    },
    iconButton: {
        padding: 2,
    },
    icon: {
        fontSize: '1.25rem',
        color: palette.icon.tertiary,
    },
});
exports.default = styles;
